var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDisable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50729 10.4115C6.37929 10.4115 6.25129 10.3628 6.15396 10.2648C5.66196 9.77346 5.39062 9.12013 5.39062 8.42546C5.39062 6.98546 6.56129 5.81413 7.99996 5.81413C8.69196 5.81413 9.36396 6.09346 9.84329 6.58079C10.0366 6.77813 10.0346 7.09413 9.83729 7.28746C9.64062 7.48213 9.32463 7.47879 9.13063 7.28279C8.83796 6.98479 8.42596 6.81413 7.99996 6.81413C7.11263 6.81413 6.39062 7.53679 6.39062 8.42546C6.39062 8.85279 6.55796 9.25546 6.86063 9.55813C7.05596 9.75346 7.05596 10.0695 6.86129 10.2648C6.76329 10.3628 6.63529 10.4115 6.50729 10.4115Z",
    fill: "#DB1818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37838 10.9941C8.14171 10.9941 7.93105 10.8248 7.88705 10.5835C7.83771 10.3121 8.01771 10.0515 8.28971 10.0021C8.94305 9.88346 9.46038 9.36479 9.57771 8.71079C9.62705 8.43946 9.88705 8.26079 10.1584 8.30746C10.4304 8.35613 10.611 8.61613 10.5624 8.88813C10.371 9.95013 9.52971 10.7928 8.46838 10.9861C8.43838 10.9915 8.40771 10.9941 8.37838 10.9941Z",
    fill: "#DB1818"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3933_24424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 12,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 3.08298H12.0577V12.4817H1.3335V3.08298Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3933_24424)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4365 12.4817C4.3285 12.4817 4.21983 12.4464 4.12783 12.3751C3.0005 11.4897 2.04783 10.1917 1.3745 8.6224C1.31983 8.49573 1.31983 8.35306 1.3745 8.22706C2.05516 6.65106 3.01383 5.3464 4.14716 4.45506C6.45783 2.6264 9.53383 2.6204 11.8678 4.4684C12.0845 4.63973 12.1212 4.9544 11.9498 5.17106C11.7778 5.3864 11.4645 5.4244 11.2472 5.2524C9.26983 3.68706 6.7225 3.6924 4.7665 5.2404C3.80916 5.99373 2.98716 7.09106 2.3805 8.42573C2.98116 9.75239 3.79583 10.8431 4.74583 11.5884C4.96316 11.7591 5.0005 12.0737 4.82983 12.2904C4.73116 12.4157 4.5845 12.4817 4.4365 12.4817Z",
    fill: "#DB1818"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3933_24424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 10,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81152 5.82746H14.6665V13.7929H5.81152V5.82746Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3933_24424)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99994 13.7929C7.37528 13.7929 6.75394 13.6916 6.15394 13.4923C5.89194 13.4049 5.74994 13.1216 5.83728 12.8596C5.92461 12.5969 6.20661 12.4576 6.46994 12.5429C6.96794 12.7089 7.48261 12.7929 7.99994 12.7929C10.2853 12.7929 12.3739 11.1649 13.6199 8.42426C13.3159 7.75826 12.9619 7.15493 12.5659 6.62826C12.3999 6.4076 12.4439 6.0936 12.6646 5.9276C12.8846 5.7616 13.1986 5.80693 13.3646 6.02693C13.8473 6.6676 14.2713 7.40826 14.6253 8.2256C14.6806 8.35226 14.6806 8.49626 14.6253 8.62226C13.2279 11.8603 10.7513 13.7929 7.99994 13.7929Z",
    fill: "#DB1818"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3933_24424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 13
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24268 2.66693H13.7583V14.1823H2.24268V2.66693Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3933_24424)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74251 14.1823C2.61451 14.1823 2.48651 14.1336 2.38918 14.0356C2.19384 13.8403 2.19384 13.5243 2.38918 13.3289L12.9052 2.81294C13.1005 2.6176 13.4165 2.6176 13.6118 2.81294C13.8072 3.00827 13.8072 3.32494 13.6118 3.52027L3.09584 14.0356C2.99851 14.1336 2.87051 14.1823 2.74251 14.1823Z",
    fill: "#DB1818"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisable);
export default __webpack_public_path__ + "static/media/iconDisable.d2df5c16d99f3e795dc8a815ca774042.svg";
export { ForwardRef as ReactComponent };